import { ICmsProduct } from '~/types/ICmsProduct';

export const buildFormContent = (product: ICmsProduct) => ({
  originPath: product.path,
  redirectPath: product.redirectPath
});
